import { z } from "zod";

const jsonSchemaType = z.enum([
  "string",
  "number",
  "integer",
  "boolean",
  "object",
  "array",
  "null",
]);

export const JsonSchemaMetadata = z.object({
  UI_ACTION: z.array(z.string()).optional(),
  UI_TYPE: z.string().optional(),
});
export type JsonSchemaMetadata = z.infer<typeof JsonSchemaMetadata>;

export const BaseJsonSchema = z
  .object({
    $ref: z.string().optional(),
    type: z.union([jsonSchemaType, z.array(jsonSchemaType)]).optional(),
    required: z.array(z.string()).optional(),
    title: z.string().optional(),
    metadata: JsonSchemaMetadata.optional(),
  })
  .passthrough();

export type BaseJsonSchema = z.infer<typeof BaseJsonSchema>;

export type JsonSchema = BaseJsonSchema & {
  items?: JsonSchema | JsonSchema[];
  properties?: Record<string, JsonSchema>;
};

export const JsonSchema: z.ZodType<JsonSchema> = BaseJsonSchema.extend({
  items: z.lazy(() => z.union([JsonSchema, z.array(JsonSchema)]).optional()),
  properties: z.lazy(() => z.record(z.string(), JsonSchema).optional()),
});

export const ObjectJsonSchema = BaseJsonSchema.extend({
  type: z.literal("object"),
  properties: z.record(z.string(), JsonSchema),
});
export type ObjectJsonSchema = z.infer<typeof ObjectJsonSchema>;
